import {
    Autocomplete,
    Box,
    FormControl,
    Grid,
    InputLabel,
    TextField,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import React, { useRef } from "react";
import Loader from "../../components/common/Loader";
import ValidationErrorMessage from "../../components/common/ValidationErrorMessage";
import { useDispatch, useSelector } from "react-redux";
import Form from "../../components/pages/register/coaching/Form";
import List from "../../components/pages/register/coaching/List";
import { PROFILE_MODES } from "../../services/constants";

const Coaching = () => {
    const formRef = useRef(null);

    const { mode } = useSelector((state) => state.personalInfo);

    const theme = useTheme();
    const isMdScreen = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <Box className="page">
            <Grid container justifyContent={"center"}>
                <Grid
                    container
                    item
                    direction={"row"}
                    rowSpacing={5}
                    columnSpacing={isMdScreen ? 0 : 10}
                    md={9}
                    sm={12}
                    xs={12}
                >
                    {mode == PROFILE_MODES.UPDATE && (
                        <Grid item xs={12}>
                            <List scrollRef={formRef} />
                        </Grid>
                    )}

                    <Grid item xs={12} ref={formRef}>
                        <Form />
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Coaching;
